var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Color from 'color';

var AdminTheme = (_temp2 = _class = function (_Component) {
    _inherits(AdminTheme, _Component);

    function AdminTheme() {
        var _temp, _this, _ret;

        _classCallCheck(this, AdminTheme);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            theme: undefined
        }, _this.componentDidUpdate = function (prevProps) {
            if (prevProps.theme !== _this.props.theme) {
                _this.getTheme();
            }
        }, _this.getContrast = function (color) {
            var contrast = void 0;

            color = Color(color);

            if (color.isDark()) {
                contrast = 'white';
            } else {
                contrast = 'black';
            }

            return contrast;
        }, _this.getTheme = function () {
            var theme = _this.props.theme;


            if (!(theme && theme.primaryColor)) {
                _this.setState({
                    theme: false
                });
            }

            var primaryColor = theme.primaryColor,
                secondaryColor = theme.secondaryColor;


            if (!secondaryColor) {
                secondaryColor = primaryColor;
            }

            primaryColor = Color(primaryColor);
            secondaryColor = Color(secondaryColor);

            var primaryContrast = _this.getContrast(primaryColor);
            var secondaryContrast = _this.getContrast(secondaryColor);

            var primaryDark = "#666";
            var primaryLight = "#999";

            if (primaryColor.isDark()) {
                primaryDark = primaryColor;
            } else {
                primaryLight = primaryColor;
            }

            _this.setState({
                theme: {
                    primaryColor: primaryColor,
                    primaryContrast: primaryContrast,
                    secondaryColor: secondaryColor,
                    secondaryContrast: secondaryContrast,
                    primaryDark: primaryDark,
                    primaryLight: primaryLight
                }
            });
        }, _this.renderStyle = function () {
            var theme = _this.state.theme;


            if (!theme) {
                return false;
            }

            var primaryColor = theme.primaryColor,
                primaryContrast = theme.primaryContrast,
                secondaryColor = theme.secondaryColor,
                secondaryContrast = theme.secondaryContrast,
                primaryDark = theme.primaryDark,
                primaryLight = theme.primaryLight;


            return React.createElement('style', { dangerouslySetInnerHTML: {
                    __html: '          \n\n        .bg-primary {\n          background-color: ' + primaryColor + ';\n          color: ' + primaryContrast + ';\n        }\n\n        .bg-secondary {\n          background-color: ' + secondaryColor + ';\n          color: ' + secondaryContrast + ';\n        }\n\n        .bg-dark {\n          background-color: ' + primaryDark + ';\n          color: white;\n        }\n\n        .bg-light {\n          background-color: ' + primaryLight + ';\n          color: black;\n        }\n        \n        .color-primary {\n          color: ' + primaryColor + ';\n        }\n\n        .color-primary-contrast {\n          color: ' + primaryContrast + ';\n        }\n\n        .color-secondary {\n          color: ' + secondaryColor + ';\n        }\n\n        .color-secondary-contrast {\n          color: ' + secondaryContrast + ';\n        }\n\n        .color-dark {\n          color: ' + primaryDark + ';\n        }\n\n        .color-light {\n          color: ' + primaryLight + ';\n        }\n        \n        .nav-action .admin-button--primary {\n          background-color: ' + primaryDark + ';\n          color: white;\n        }\n\n        .nav-path .admin-button[aria-selected="true"] {\n          color: ' + primaryDark + ';\n        }\n        \n        a {\n          color: ' + primaryDark + ';\n        }\n        \n      ' } });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    AdminTheme.prototype.componentDidMount = function componentDidMount() {
        this.getTheme();
    };

    AdminTheme.prototype.render = function render() {
        var theme = this.state.theme;


        if (!(theme && theme.primaryColor)) {
            return this.props.children;
        }

        return React.createElement(
            'div',
            { className: 'admin__theme' },
            this.renderStyle(),
            this.props.children
        );
    };

    return AdminTheme;
}(Component), _class.defaultProps = {
    theme: {
        primaryColor: '#666'
    }
}, _temp2);


export default AdminTheme;